import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export function Section({
  id,
  className,
  children,
}: {
  id?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className={cn("section-y relative", className)}>
      <div className="container-page">{children}</div>
    </section>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  className,
}: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "center" | "start";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "max-w-3xl",
        align === "center" ? "mx-auto text-center" : "text-start",
        className,
      )}
    >
      {eyebrow ? (
        <p className="mb-4 text-sm font-medium tracking-wide text-emerald-300/90">
          {eyebrow}
        </p>
      ) : null}
      <h2 className="text-display text-3xl leading-tight font-semibold sm:text-4xl md:text-[2.75rem]">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-5 text-base text-cream-100/60 md:text-lg">{subtitle}</p>
      ) : null}
    </div>
  );
}

export function Rule({ className }: { className?: string }) {
  return <div aria-hidden className={cn("rule-fade", className)} />;
}
